import types from './types';
import { serviceActions } from 'state/modules/service';
import getClientMutationId from '../../../utils/getClientMutationId';
import { AlertType } from '../../../graphql/schema/p4types';

export function initializeViews({
  screenName,
  defaultViewConfig,
  columnOverrides,
  resetDefaultView,
  availableColumns,
  views,
  viewName = undefined, //Not sure if this 'should' be optional, but it's used that way so allowing it for now.
}) {
  return function (dispatch, getState) {
    const defaultViewId = null;
    const loadViews = !views || !views[screenName] || !views[screenName].viewsLoaded;

    // If views are already loaded then both screen details and view details must be available, otherwise load them
    if (loadViews) {
      return dispatch({
        type: types.INITIALIZE_VIEWS,
        screenName,
        views,
        availableColumns,
        defaultViewConfig,
        columnOverrides,
        defaultViewId,
        viewName,
      });
    }
    if (resetDefaultView) {
      dispatch({
        type: types.RESET_DEFAULT_VIEW,
        screenName,
        defaultViewConfig,
      });
    }

    return {};
  };
}

export function resetDefaultView({ screenName, defaultViewConfig }) {
  return {
    type: types.RESET_DEFAULT_VIEW,
    screenName,
    defaultViewConfig,
  };
}

export function updateFilters(screenName, addFilters, removeFilters, changeFilters) {
  return { type: types.UPDATE_FILTERS, screenName, addFilters, removeFilters, changeFilters };
}

export function updateFilter(screenName, filter) {
  return { type: types.UPDATE_FILTER, screenName, filter };
}

export function updateGenericFilter(screenName, filterText) {
  return { type: types.UPDATE_GENERIC_FILTER, screenName, filterText };
}

export function updateColumns(screenName, selectedColumns) {
  return { type: types.UPDATE_COLUMNS, screenName, selectedColumns };
}

export function moveColumn(screenName, fieldName, newIndex) {
  return { type: types.MOVE_COLUMN, screenName, fieldName, newIndex };
}

export function resizeColumn(screenName, fieldName, newWidth) {
  return { type: types.RESIZE_COLUMN, screenName, fieldName, newWidth };
}

export function updateSort(screenName, fieldName, isDescending) {
  return { type: types.UPDATE_SORT, screenName, fieldName, isDescending };
}

export function switchView(screenName, viewName) {
  return { type: types.SWITCH_VIEW, screenName, viewName };
}

export function toggleHideConfiguration(screenName) {
  return { type: types.TOGGLE_HIDE_CONFIGURATION, screenName };
}

export function saveView(screenName, viewName, result) {
  return {
    type: types.SAVE_VIEW,
    screenName: screenName,
    viewName: viewName,
    response: result,
  };
}

function deleteViewSuccess(screenName, viewId) {
  return {
    type: types.DELETE_VIEW_SUCCESS,
    screenName: screenName,
    viewId: viewId,
  };
}

function defaultViewMutation(viewMutation, viewId, viewConcurrency, dispatch, screenName, refreshViews) {
  return viewMutation({
    variables: {
      input: {
        clientMutationId: getClientMutationId(),
        view: {
          id: viewId,
          concurrencyVersion: viewConcurrency,
          primaryView: true,
        },
      },
    },
  })
    .then(({ data }) => {
      if (data.viewUpdate && data.viewUpdate.result) {
        dispatch(
          serviceActions.genericAlert('Default View', 'The default view was updated successfully', AlertType.Success)
        );
        refreshViews();
        dispatch(saveView(screenName, data.viewUpdate.result.name, data.viewUpdate.result));
      } else {
        dispatch(
          serviceActions.genericAlert('Default View could not be set', 'An error occurred setting the default view')
        );
      }
    })
    .catch((error) => {
      dispatch(
        serviceActions.genericAlert('Default view could not be set', 'An error occurred setting the default view')
      );
    });
}

export function setDefaultView(screenName, viewId, viewMutation, refreshViews) {
  return function (dispatch, getState) {
    const views = getState().views[screenName];
    const viewName = Object.keys(views.view).find((viewName) => {
      return views.view[viewName].id === viewId;
    });
    const concurrencyVersion = views.view[viewName].concurrencyVersion;

    return defaultViewMutation(viewMutation, viewId, concurrencyVersion, dispatch, screenName, refreshViews);
  };
}

export default {
  initializeViews,
  updateFilters,
  updateFilter,
  updateGenericFilter,
  updateColumns,
  moveColumn,
  resizeColumn,
  updateSort,
  switchView,
  toggleHideConfiguration,
  saveView,
  deleteViewSuccess,
  setDefaultView,
  resetDefaultView,
};
